import React from "react";
import i18next from "../localization/i18n";
import MapIcon from "@mui/icons-material/Map";
import SaitRowAction from "./SaitRowAction";

/*
	Obbligatori:
		id
		onClick
	Facoltativi:
*/

export default function SaitRowActionMaps(config) {
	return SaitRowAction({
		id: config.id,
		icon: <MapIcon color="success" />,
		tooltip: i18next.t("open_directions"),
		onClick: (params) => {
			window.open("https://maps.google.it?q=" + config.address(params));
		},
		conditionalRendering: (params) => {
			return config.address(params);
		},
		roleSecurity: config.roleSecurity,
		objmod: config.objmod,
		hidden: config.hidden,
	});
}
